import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getCustomerConversionById,getCustomerConversionFollowListByCustomerConversionId } from '@/api/customer'
import { menuBtn } from '@/utils/menu_level2_button'

@Component({})
export default class TransfromCustomerInfo extends Vue {
    culesInfoShow = false
    customerInfoShow = true
    operationShow = true
    id: number;
    infoData: any = ''
    // 跟进记录
    tableData = []
    page = 1
    limit = 20
    total = 0
    loading = false

    informationListImg: any = []
    menuBtn = menuBtn
    activities = []

    // created()
    created() {
        const query = this.$route.query
        this.id = Number(query.id)

        this.getCustomerConversionById()
        this.$nextTick(() => {
            (this.$refs['el-table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {
                        return
                    }
                    this.limit += 20
                    this.getTableData()
                }
            }, true);
        })
        this.getTableData()
    }

    // methods
    formatDate = formatDate
    clickEditBtn() {
        this.$router.push('transfromCustomerEdit?id=' + this.id)
    }
    async getCustomerConversionById() {
        const loading = this.$loading({
            lock: true,
            text: '正在加载',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        const data: any = await getCustomerConversionById(this.id)

        this.infoData = JSON.parse(JSON.stringify(data.customerConversion))
        //    审批流程
        this.activities = data.customerConversion.messageReviewList
        const list = []
        const list1 = this.infoData.informationList
        list1.forEach((item)=>{
            if(item) {
                const url = decodeURI(item)
                const str = url.split('/crm/')[1];
                if(str) {
                    const name = str.slice(20);
                    const obj = {name: name, url: item}
                    list.push(obj)
                }
                if(this.fileExtension(item)==='png'|| this.fileExtension(item.url)=='PNG'|| this.fileExtension(item.url)=='JPG' || this.fileExtension(item)==='jpg' || this.fileExtension(item.url)=='JPEG'|| this.fileExtension(item)==='jpeg'){
                    this.informationListImg.push(item)
                }
            }
        })
        this.infoData.informationList = list
        setTimeout(() => {
            loading.close();
        }, 2000);
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    clickFllowBtn() {
        this.$router.push({
            path: '/customer/transfromCustomerFollow',
            query: {
                id: String(this.id),
                name: this.infoData.realName ? this.infoData.realName : this.infoData.marketClue.name
            }
        })
    }
    // 跟进记录
    async getTableData() {
        this.loading = true
        const data: any = await getCustomerConversionFollowListByCustomerConversionId({
            page: this.page,
            limit: this.limit,
            customerConversionId: this.id
        })
        this.total = data.allNum
        this.tableData = data.customerConversionFollowList
        // this.tableData = this.tableData.map((item: any) => ({ ...item, createdAt: item.createdAt.split(":")[0], }))
        this.loading = false
    }
}
